const DashboardTypes = {
    GET_GLOBAL_SEARCH: "GET_GLOBAL_SEARCH",
    GET_GLOBAL_SEARCH_LOADING: "GET_GLOBAL_SEARCH_LOADING",
    GET_GLOBAL_SEARCH_SUCCESS: "GET_GLOBAL_SEARCH_SUCCESS",
    GET_GLOBAL_SEARCH_RESET: "GET_GLOBAL_SEARCH_RESET",
    GET_GLOBAL_SEARCH_ERROR: "GET_GLOBAL_SEARCH_ERROR",
};

export default DashboardTypes;
